import { render, staticRenderFns } from "./Stock_Producto.vue?vue&type=template&id=e93fd62a"
import script from "./Stock_Producto.vue?vue&type=script&lang=js"
export * from "./Stock_Producto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports